import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ItemContainerMode extends Cloneable {
    static DISABLED = new ItemContainerMode(0, "DISABLED");
    static ENABLED = new ItemContainerMode(1, "ENABLED");

    static _values = [
        this.DISABLED,
        this.ENABLED
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ItemContainerMode.getValue(id));
        });
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof ItemContainerMode) {
            return ItemContainerMode._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "NONE") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof ItemContainerMode) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemContainerMode());
        } else if (target instanceof ItemContainerMode) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemContainerMode, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});